import { ActivityEntityName } from '../entities/shared/activity.entity.name';
import { EntitySecurityFacts } from './entity.security.facts';

export type EntitySecurityCapabilityResolver<TEntity = unknown, TCapabilities = unknown> = (facts: EntitySecurityFacts<TEntity>) => TCapabilities;

export class EntitySecurityCapabilityRegistry {

    private static readonly resolvers = new Map<ActivityEntityName, EntitySecurityCapabilityResolver>();

    public static register<TEntity, TCapabilities>(entityName: ActivityEntityName, resolver: EntitySecurityCapabilityResolver<TEntity, TCapabilities>): void {

        this.resolvers.set(entityName, resolver as EntitySecurityCapabilityResolver);
    }

    public static get<TCapabilities>(entityName: ActivityEntityName, facts: EntitySecurityFacts): TCapabilities {

        const resolver = this.resolvers.get(entityName);

        return resolver
            ? resolver(facts) as TCapabilities
            : {} as TCapabilities;
    }
}
